import { Model as i } from "../../../model.js";
class u extends i {
  constructor(t, s, o, e) {
    super(), this.source = t, this.status = s, this.tags = o, this.needVerification = e;
  }
}
export {
  u as CustomerConfigurationModel
};
//# sourceMappingURL=customerConfiguration.model.js.map
